import n from "./index577.mjs";
import m from "./index578.mjs";
import { unsafeStringify as t } from "./index579.mjs";
function x(r, e, a) {
  if (n.randomUUID && !r)
    return n.randomUUID();
  r = r || {};
  const f = r.random || (r.rng || m)();
  return f[6] = f[6] & 15 | 64, f[8] = f[8] & 63 | 128, t(f);
}
export {
  x as default
};
